// 🧭 hooks/UserFriendsNavigation.js
import { useNavigate } from "react-router-dom";

const UserFriendsNavigation = (userId) => {
  const navigate = useNavigate();

  const goToUserFriends = () => {
    if (!userId) {
      console.warn("⚠️ userId not set yet — navigation aborted.");
      return;
    }
    navigate(`/user-friends/${userId}`);
  };

  return { goToUserFriends };
};

export default UserFriendsNavigation;
